import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowUpRightFromSquare } from "@fortawesome/pro-solid-svg-icons"

type Props = {
  jobId: number
}

const OpenJobLink = ({ jobId }: Props) => {
  const openJob = () => window.open(`/#!/job-redirect/${jobId}`, '_blank')

  return (
    <FontAwesomeIcon
      icon={faArrowUpRightFromSquare}
      style={{ color: '#1677ff', cursor: 'pointer', fontSize: '14px' }}
      role="button"
      tabIndex={0}
      aria-label="Open job in new tab"
      onClick={openJob}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          openJob()
        }
      }}
    />
  )
}

export default OpenJobLink
